// Modalstreifen: je Tag beziehungsweise je Meeting ein Band in der Farbe des
// wahrscheinlichsten Ausgangs. Tage mit Qualitätsflag werden gedämpft statt
// ausgelassen — eine Lücke würde suggerieren, dass nichts passiert ist.

import * as d3 from "d3";

import { binColor } from "../../palette";
import type { G, Model } from "../model";

export function drawStrip(g: G, model: Model): void {
    const { stripTop, stripH } = model.layout;

    g.selectAll("rect.hist")
        .data(model.vis)
        .join("rect")
        .attr("class", "hist")
        .attr("x", (d) => model.x(d.date))
        .attr("y", stripTop)
        .attr("width", model.dayW)
        .attr("height", stripH)
        .attr("fill", (d) => binColor(model.deltas[d.modal]))
        .attr("opacity", (d) => (d.flagged ? 0.28 : 0.85));

    g.selectAll("rect.fwd")
        .data(d3.range(model.nF))
        .join("rect")
        .attr("class", "fwd")
        .attr("x", (i) => model.xF(i) - model.colW / 2)
        .attr("y", stripTop)
        .attr("width", model.colW)
        .attr("height", stripH)
        .attr("fill", (i) => binColor(model.deltas[model.fwdModal[i]]))
        .attr("opacity", 0.85);
}
